// extracted by mini-css-extract-plugin
module.exports = {"container":"Experience_container__2--Qp","body":"Experience_body__3lgrd","expContainer":"Experience_expContainer__RKhSD","expCard":"Experience_expCard__y6Rhb"};